import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { OverflowState } from '@prlw/libs/overflow-fader/overflow-fader.class';
import { ResponsiveService } from '@prlw/libs/responsive/responsive.service';

@Component({
  selector: 'prlw-table-header-row',
  templateUrl: './table-header-row.component.html',
  styleUrls: ['./table-header-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableHeaderRowComponent {
  @Input() overflows?: OverflowState;

  @Output() eventOpenManage = new EventEmitter<void>();

  handleOpenManage() {
    this.eventOpenManage.emit();
  }

  constructor(private readonly responsiveService: ResponsiveService) {}

  xsmall$ = this.responsiveService.xsmall$;
}
